import constants from "../utils/Constants";
import { deleteData, getData, postData, putData } from "./rest-api-helper";


export async function getCompaniesServ(userType, userId) {
    if (userType === constants.ma || userType === constants.admin || userType === constants.accounts || userType === constants.store) {
        const details = {
            urlPath: `/company`
        }
        const res = await getData(details);
        return res.data;
    } else {
        const details = {
            urlPath: `/source/getAllComBySource`,
            queryParams: {
                userId
            }
        }
        const res = await getData(details);
        return res.data;
    }
}


export async function createComServ(data) {
    const details = {
        urlPath: "/company",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getSingleComServ(comId) {
    const details = {
        urlPath: `/company/single/${comId}`
    }
    const res = await getData(details);
    return res.data;
}


export async function editComServ(data, comId) {
    const details = {
        urlPath: `/company/editCom/${comId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getComProdServ({ comId, catId, subCatId, limit, pageNumber, searchKeyWord, order }) {
    const details = {
        urlPath: "/company/product",
        queryParams: {
            ...(comId && { comId }),
            ...(catId && { catId }),
            ...(subCatId && { subCatId }),
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getComCatServ({ comId, limit, pageNumber, order }) {
    const details = {
        urlPath: "/company/categories",
        queryParams: {
            ...(comId && { comId }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}


export async function getComSubCatServ({ comId, catId, limit, pageNumber, order }) {
    const details = {
        urlPath: "/company/subCat",
        queryParams: {
            comId,
            catId,
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getProdsNotInCatServ({ comId, limit, pageNumber, searchKeyWord, searchKeyType, order }) {
    const details = {
        urlPath: "/company/getProdsNotInCat",
        queryParams: {
            ...(comId && { comId }),
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(searchKeyType && { searchType: searchKeyType }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function CreateCatalogServ(data) {
    const details = {
        urlPath: "/company/addProdToCom",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}


export async function updateProdAgreeServ(data) {
    const details = {
        urlPath: `/company/product/updateAgreeDetails`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getComEmpServ({ comId, limit, pageNumber, searchWord, type, projIdStrg, userType, status }) {
    if (type === 'amtc') {
        const details = {
            urlPath: "/company/employees",
            queryParams: {
                ...(comId && { comId }),
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(userType && { userType }),
                ...(status && { status }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
    if (type === 'com') {
        const details = {
            urlPath: "/projects/employees",
            queryParams: {
                ...(projIdStrg && { projIdStrg }),
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(userType && { userType }),
                ...(status && { status }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
}


export async function getSingleComUserServ(userId) {
    const details = {
        urlPath: "/company/user/single",
        queryParams: {
            userId
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getUserDDForAssignServ(comId, userType) {
    const details = {
        urlPath: "/company/getUserDDForAssign",
        queryParams: {
            comId, userType
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getAllComDDServ() {
    const details = {
        urlPath: "/company/getAllComDD"
    }
    const res = await getData(details);
    return res.data;
}

export async function getSingleComProdServ(amtcProdIdStrg) {
    const details = {
        urlPath: `/company/product/single/${amtcProdIdStrg}`,
    }
    const res = await getData(details);
    return res.data;
}

export async function getComAddProdSrchServ({ comId, searchWord }) {
    const details = {
        urlPath: "/company/getComAddProdSrch",
        queryParams: {
            ...(comId && { comId }),
            ...(searchWord && { amtcProdIdStrg: searchWord })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function sendPOServ(data) {
    const details = {
        urlPath: "/company/sendPO",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function approveUserServ(userId) {
    const details = {
        urlPath: `/company/user/approve/${userId}`,
    }
    const res = await putData(details);
    return res;
}

export async function getNotApprComEmpServ({ comId, limit, pageNumber, searchWord }) {
    const details = {
        urlPath: "/company/getEmpCreatReq",
        queryParams: {
            ...(comId && { comId }),
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getNotApprDeptServ({ comId, limit, pageNumber, searchWord }) {
    const details = {
        urlPath: "/company/getDeptCreatReq",
        queryParams: {
            ...(comId && { comId }),
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function rmvProdFromCatalogServ({ comId, comProdIdStrg, amtcProdIdStrg }) {
    const details = {
        urlPath: "/company/rmvProduct",
        queryParams: {
            comId, comProdIdStrg, amtcProdIdStrg
        }
    }
    const res = await putData(details);
    return res;
}

export async function addPoServ(data) {
    const details = {
        urlPath: "/pot/add",
        body: {
            ...data
        }
    }

    const res = await postData(details);
    return res;
}